import { createAction, props } from '@ngrx/store';
import { JobAlertRuleDisplay } from 'src/app/recruiting/dashboard/models/job-alert-rule-display.model';
import { RecruitingDashboardAlert } from 'src/app/recruiting/dashboard/models/recruiting-dashboard-alert.model';
import { JobAlertDto } from 'src/app/shared/models/job-alert.model';

export const jobUpdated = createAction('[HUB CONNECTION SERVICE] job updated');
export const jobUpdatedAlertsSuccess = createAction(
    '[HUB CONNECTION SERVICE] Job Updated Success',
    props<{ jobAlert: JobAlertDto }>()
);
export const jobUpdatedAlertsFailure = createAction(
    '[HUB CONNECTION SERVICE] Job Updated Failure',
    props<{ error: unknown }>()
);
export const jobAlertsForRecruiter = createAction('[JOBS SERVICE] Get Job Alerts For Recruiter');
export const jobAlertsSuccess = createAction(
    '[JOBS SERVICE] Get Job Alerts Success',
    props<{ jobAlerts: JobAlertDto[] }>()
);
export const jobAlertsFailure = createAction('[JOBS SERVICE] Get Job Alerts Failure', props<{ error: unknown }>());
export const leadAssignedAlertSuccess = createAction(
    '[HUB CONNECTION SERVICE] Lead Assigned Success',
    props<{ message: number }>()
);
export const leadAssignedAlertFailure = createAction(
    '[HUB CONNECTION SERVICE] Lead Assigned Failure',
    props<{ error: unknown }>()
);
export const recruitingDashboardAlertSuccess = createAction(
    '[HUB CONNECTION SERVICE] Recruiting Dashboard Alert Success',
    props<{ data: RecruitingDashboardAlert }>()
);
export const recruitingDashboardAlertFailure = createAction(
    '[HUB CONNECTION SERVICE] Recruiting Dashboard Alert Failure',
    props<{ error: unknown }>()
);
export const recruitingDashboardJobAlertSuccess = createAction(
    '[HUB CONNECTION SERVICE] Recruiting Dashboard Job Alert Success',
    props<{ data: JobAlertDto[] }>()
);
export const recruitingDashboardJobAlertFailure = createAction(
    '[HUB CONNECTION SERVICE] Recruiting Dashboard Job Alert Failure',
    props<{ error: unknown }>()
);

export const recruiterDashboardViewed = createAction(
    '[RECRUITER DASHBOARD COMPONENT] - Dashboard Viewed',
    props<{ userId: number }>()
);

export const recruiterJobAlertsViewOpened = createAction(
    '[RECRUITER DASHBOARD COMPONENT] - Job Alerts View Opened',
    props<{ userId: number }>()
);

export const getJobAlertRulesSuccess = createAction(
    '[JOB ALERT SERVICE] Get Job Alert Rules Success',
    props<{ jobAlertRules: JobAlertRuleDisplay[] }>()
);

export const getJobAlertRulesFailure = createAction(
    '[JOB ALERT SERVICE] Get Job Alert Rules Failure',
    props<{ error: unknown }>()
);

export const getJobAlertRuleSuccess = createAction(
    '[JOB ALERT SERVICE] Get Job Alert Rule Success',
    props<{ jobAlertRule: JobAlertRuleDisplay }>()
);

export const getJobAlertRuleFailure = createAction(
    '[JOB ALERT SERVICE] Get Job Alert Rule Failure',
    props<{ error: unknown }>()
);

export const getLatestJobAlertsViewSuccess = createAction(
    '[USER EVENT SERVICE] - Get Latest Job Alerts View Success',
    props<{ eventTimestamp: Date }>()
);

export const getLatestJobAlertsViewFailure = createAction(
    '[USER EVENT SERVICE] - Get Latest Job Alerts View Failure',
    props<{ error: unknown }>()
);

export const addJobAlertsViewEventSuccess = createAction(
    '[USER EVENT SERVICE] - Add Job Alerts View Event Success',
    props<{ userId: number }>()
);

export const addJobAlertsViewEventFailure = createAction(
    '[USER EVENT SERVICE] - Add Job Alerts View Event Failure',
    props<{ error: unknown }>()
);

export const createJobAlertRuleSuccess = createAction(
    '[JOB ALERT SERVICE] Job Alert Rule Created',
    props<{ userId: number; ruleName: string }>()
);

export const jobAlertRuleUpdated = createAction(
    '[EDIT JOB ALERT RULE COMPONENT] Edit Job Alert Rule',
    props<{ userId: number; ruleName: string }>()
);

export const updateJobAlertRuleSuccess = createAction(
    '[JOB ALERT SERVICE] Job Alert Rule Updated',
    props<{ userId: number; ruleName: string }>()
);

export const updateJobAlertRuleFailure = createAction(
    '[JOB ALERT SERVICE] Update Job Alert Rules Failure',
    props<{ error: unknown }>()
);

export const deleteJobAlertRuleSuccess = createAction(
    '[JOB ALERT SERVICE] Job Alert Rule Deleted',
    props<{ ruleId: number }>()
);
